export const facebookPixel = {
  title: "Facebook Pixel",
  description:
    "Connect your Facebook Pixel to track store traffic and conversions.",
  configure: "Set up",
  edit: "Edit",
  disconnect: "Disconnect",
  disconnectConfirm: "Do you want to disconnect Facebook Pixel from your store?",
  disconnectSuccess: "Facebook Pixel disconnected",
  disconnectError: "Could not disconnect Facebook Pixel",
  connectedTitle: "Facebook Pixel connected",
  connectedDescription: "Your meta tag is active in the store.",
  needTitle: "Connect Facebook Pixel",
  needDescription:
    "Paste your Pixel meta tag to measure conversions and optimize ads.",
  metaTagLabel: "Meta tag / Pixel ID",
  metaTagPlaceholder: "Paste your Facebook Pixel meta tag here",
  eventsManagerLink: "Go to Meta Events Manager",
  eventsManagerHint:
    "Open Meta Events Manager, copy your Pixel and paste it here.",
  save: "Save",
  saving: "Saving...",
  saveSuccess: "Facebook Pixel updated successfully",
  saveError: "Could not update Facebook Pixel",
  helpTitle: "Facebook Pixel help",
  commonQuestions: "Frequently asked questions",
  helpEmpty: "No help information is available right now.",
  acquire: {
    title: "Activate Facebook Pixel",
    description:
      "Optimize Facebook and maximize conversions with accurate store data.",
    cta: "Get add-on",
  },
};

export default facebookPixel;
